import { graphql } from "src/gql"
import { GetVaultUserInfoQuery } from "src/gql/graphql"
import { graphqlClient, httpRequest } from "@myvp/shared/src/functions/request"
import { Destination } from "src/pages/sponsors-redirect"

export const getVaultUserInfo = async () => {
  const query = graphql(/* GraphQL */ `
    query getVaultUserInfo {
      getVaultUserInfo {
        userTimezone
        userLocale
      }
    }
  `)
  const result = await graphqlClient.request(query)
  return result.getVaultUserInfo
}

export const getVaultUserMetadata = async (): Promise<{
  userTimezone?: string
  userLocale?: string
}> => {
  const metadata = sessionStorage.getItem("metadata") ?? "{}"
  return JSON.parse(metadata) || {}
}

export const setVaultUserMetadata = async (
  metadata: GetVaultUserInfoQuery["getVaultUserInfo"]
) => {
  sessionStorage.setItem("metadata", JSON.stringify(metadata))
}

export const getVaultDns = async (args: { vaultId: string }) => {
  const query = graphql(/* GraphQL */ `
    query getVaultDns($input: GetVaultDnsInput!) {
      getVaultDns(input: $input) {
        vaultDns
      }
    }
  `)

  const result = await graphqlClient.request(query, {
    input: {
      vaultId: args.vaultId,
    },
  })
  return result.getVaultDns
}

/**
 * Specifically no return type, we don't care if this returns true or false, we just care if it throws or not
 */
export const isValidVaultSession = async () => {
  await httpRequest("/auth/is-valid-vault-session")
  return true
}

export const embeddedLogin = async (args: {
  destination: Destination
  vaultDns: string
  vaultId: string
  sessionToken: string
}) => {
  await httpRequest("auth/login-embedded", {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    method: "POST",
    body: new URLSearchParams({
      destination: args.destination,
      tk: args.sessionToken,
      vaulttype: "epro",
      vaultdns: args.vaultDns,
      vaultid: args.vaultId,
    }),
  })
}
